export default __webpack_public_path__ + "static/media/admin_img.24330bea.jpg";